<template lang="pug">
ul.nav
  li.nav-item
    router-link.nav-link(:to="{ path: '/dojo/classRoom' }") {{ $t('attendClass')}}
  li.nav-item(v-if="profile_base.is_enabled_vip_product && getCanOrderClass")
    .nav-link {{ $t('bookClass') }}
    ul.subnav
      span.subnav-link.subnav-sort {{ $t('book') }}
      li.subnav-item(v-for="item in bookLists" :key="item.name")
        router-link.dropdown-item.subnav-link(:to="{ path: item.path }") {{ $t(item.name) }}
      span.subnav-link.subnav-sort {{ $t('setRecord') }}
      li.subnav-item(v-for="item in setRecordLists" :key="item.name")
        router-link.dropdown-item.subnav-link(:to="{ path: item.path }") {{ $t(item.name) }}
  li.nav-item
    .nav-link {{ $t('classRecord') }}
    ul.subnav
      li.subnav-item(v-for="item in classRecordLists" :key="item.name")
        //- router-link.dropdown-item.subnav-link(:to="{ path: item.path }") {{ $t(item.name) }}
        router-link.dropdown-item.subnav-link(v-if="item.authorityTag && item.name !== 'learnRecords'" :to="{ path: item.path }") {{ $t(item.name) }}
        a.dropdown-item.subnav-link(v-if="item.authorityTag && item.name === 'learnRecords'" :href="`${newJrUrl}${item.path}`") {{ $t(item.name) }}
      span.subnav-link.subnav-sort P21音檔
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B1LIO" target="_blank") B1
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B2LIO" target="_blank") B2
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B3LIO" target="_blank") B3
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B4LIO" target="_blank") B4
      span.subnav-link.subnav-sort R21音檔
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B1LIO" target="_blank") B1
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B2LIO" target="_blank") B2
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B3LIO" target="_blank") B3
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B4LIO" target="_blank") B4
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B5LIO" target="_blank") B5
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B6LIO" target="_blank") B6
      li.subnav-item
        a.dropdown-item.subnav-link(href="https://www.cavesbooks.com.tw/EC/book_fair.aspx#3191" target="_blank") 魔法故事屋
  li.nav-item
    router-link.nav-link(:to="{ path: '/dojo/vip_mgm' }") {{ $t('vipMgm')}}
  li.nav-item
    router-link.nav-link(:to="{ path: '/dojo/guide' }") {{ $t('guide')}}
  //- li.nav-item
  //-   router-link.nav-link(:to="{ path: '/dojo/wushare/coupon_list' }") {{ $t('couponList')}}
  //- li.nav-item
  //-   router-link.nav-link(:to="{ path: '/dojo/coupon' }") {{ $t('couponCourse')}}
  //- 為了防止正常目錄在手機瀏覽器被蓋住(By 4年前寫的人)
  li(style="height: 40px;")
    p

</template>

<script>
import i18n from '@/components/nav/lang';
import navList from '@/components/nav/navList';
import lioshutanApi from '@/api';
export default {
  name: 'VipLeftNav',

  props: {
  },

  i18n,

  data() {
    return {
      newJrUrl: new URL(window.location).origin,

      bookLists: navList.vip.bookLists,

      setRecordLists: navList.vip.setRecordLists,

      classRecordLists: navList.vip.classRecordLists,
      profile_base: {
        english_name: 'English Name',
        photo: '',
      },
    };
  },
  computed: {
    getCanOrderClass() {
      return this.$store.getters['vipAccount/getCanOrderClass'];
    },
  },
  async mounted() {
    this.getStudentPorfile();
    await this.getVipPointSuggest();
  },
  methods: {
    getStudentPorfile(){
      lioshutanApi.vip.getBaseProfile().then((result) => {
        this.profile_base = { ...result.data.profile_base, ...result.data.customized_classroom_rule };
      });
    },
    async getVipPointSuggest() {
      if (localStorage.getItem('wuwow_token')){
        const res = await lioshutanApi.vip.getContractElapsedTime();
        this.$store.dispatch('vipAccount/setPlatform', res.data.platform);
      }
    },
  },
};
</script>

